/**
 * The Good Season monogram (ADR-0033, framed into the app by ADR-0094).
 *
 * The two paths are copied from `docs/marketing/logo/mark.svg`, the one source
 * for the mark, and are not redrawn. Navy G, red S. The `onNavy` variant swaps
 * the G to white so it stays legible on a navy background; the red S is
 * readable on both.
 *
 * Colours are the brand tokens in `tokens.css` rather than literals, so the
 * mark and the navy bar beside it cannot drift apart.
 *
 * One accessible name, on the image itself: `role="img"` with the label
 * "Good Season", so a screen reader announces the brand once and not as a pair
 * of unlabelled shapes.
 */

export interface BrandMarkProps {
  /** `onNavy` draws the G in white. Default draws it in brand navy. */
  readonly variant?: 'default' | 'onNavy';
  readonly className?: string | undefined;
}

export function BrandMark({ variant = 'default', className }: BrandMarkProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 679 368"
      width="74"
      height="40"
      role="img"
      aria-label="Good Season"
      data-variant={variant}
    >
      <path
        fill={variant === 'onNavy' ? 'var(--color-brand-on-navy)' : 'var(--color-brand-navy)'}
        d="M130 0L380 0L384 3L363 92L355 106L157 105L144 119L110 251L110 261L120 268L215 268L231 262L239 228L163 227L181 165L340 164L289 361L283 367L39 368L17 363L2 346L1 323L78 37L98 12Z"
      />
      <path
        fill="var(--color-brand-red)"
        d="M456 0L678 1L679 9L654 103L647 106L392 106L411 31L428 11ZM383 134L588 135L630 181L619 234L611 239L424 239L408 235L368 196ZM348 267L610 267L610 270L592 337L576 356L562 364L543 368L327 368L320 365L320 358L342 273Z"
      />
    </svg>
  );
}
